export default "__VITE_ASSET__DlREqBj6__"